import { Injectable, inject, signal } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

export type NavDirection = 'forward' | 'back';

/**
 * Tracks whether the current navigation is moving forward (a new route was
 * pushed) or back (browser/back-button/edge-swipe pop). Route transitions read
 * this to decide which way pages slide, mirroring native push/pop. A popstate
 * trigger means the user went back; everything else is treated as forward.
 */
@Injectable({ providedIn: 'root' })
export class NavigationDirectionService {
  private readonly router = inject(Router);
  private readonly _direction = signal<NavDirection>('forward');
  readonly direction = this._direction.asReadonly();

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._direction.set(event.navigationTrigger === 'popstate' ? 'back' : 'forward');
      }
    });
  }
}
